import { Component, OnInit, Input } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { NoteService } from '../../services/note.service';
import { ContractService } from '../../services/contract.service';

import { NoteDetail } from 'src/app/models/note';
import { EsignNoteDetail } from 'src/app/models/contract';

export enum NoteDetailTypes {
  Loan,
  Esign
}

@Component({
  selector: 'app-note-detail',
  templateUrl: './note-detail.component.html',
  styleUrls: ['./note-detail.component.scss']
})
export class NoteDetailComponent implements OnInit {
  private _noteId = 0;

  @Input() noteDetailType = NoteDetailTypes.Loan;

  @Input()
  set noteId(noteId: number) {
    this._noteId = noteId || 0;
    this.getData();
  }
  get noteId(): number {
    return this._noteId;
  }

  private _handleError: HandleError;
  private _logging = environment.logging;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  showSpinner = false;

  noteDetail: NoteDetail;
  esignNoteDetail: EsignNoteDetail;
  noteDetailTypes = NoteDetailTypes;

  constructor(
    private _errorHandler: ErrorHandler,
    private _noteService: NoteService,
    private _contractService: ContractService,
    public media: MediaObserver
  ) {
    this._handleError = _errorHandler.createHandleError('NoteDetailComponent');
  }

  ngOnInit() {}

  getData(): void {
    this.showSpinner = true;
    switch (this.noteDetailType) {
      case this.noteDetailTypes.Loan: {
        this.getNoteDetail(this._noteId);
        break;
      }
      case this.noteDetailTypes.Esign: {
        this.getEsignNoteDetail(this._noteId);
        break;
      }
    }
  }

  getNoteDetail(noteId: number): void {
    this.showSpinner = true;
    this._noteService.getNoteDetail(noteId).subscribe(
      result => {
        this.noteDetail = result;
        if (this._logging.serviceCallTraceLog) {
          console.log('NoteDetailComponent.getNoteDetail :: result.noteId = ' + result.noteId);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('NoteDetailComponent.getNoteDetail :: result = ' + JSON.stringify(result));
        }
        this.getDataComplete();
      },
      error => this._handleError('getNoteDetail', error)
    );
  }

  getEsignNoteDetail(noteId: number): void {
    this.showSpinner = true;
    this._contractService.getEsignNoteDetail(noteId).subscribe(
      result => {
        this.esignNoteDetail = result;
        if (this._logging.serviceCallTraceLog) {
          console.log('NoteDetailComponent.getEsignNoteDetail :: result.noteId = ' + result.noteId);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('NoteDetailComponent.getEsignNoteDetail :: result = ' + JSON.stringify(result));
        }
        this.getDataComplete();
      },
      error => this._handleError('getEsignNoteDetail', error)
    );
  }

  getDataComplete(): void {
    this.showSpinner = false;
  }

  getToolTip(element: string): string {
    let toolTip: string;
    switch (element.toUpperCase().trim()) {
      case 'PAYOFFAMOUNT': {
        toolTip =
          // tslint:disable-next-line:max-line-length
          'Payoff Amount is calculated using a payoff date of today and considers the disbursed principal amount, unpaid interest and all fees due as well as any pending disbursements. \n\n You will be responsible for any late fees and additional accrued interest that are assessed to your loan(s) between today and the date payment is received. Please contact our Customer Service Department via the "Contact Us" link if you have additional questions related to your final payoff amount.';
        break;
      }
      case 'MAXINTERESTRATE': {
        toolTip =
          'Maximum/contractual Interest Rate is the highest interest rate that can be charged during the repayment of your account.';
        break;
      }
      case 'CONTRACTINTERESTRATE': {
        toolTip =
          // tslint:disable-next-line:max-line-length
          'Current Interest Rate is the current interest rate accruing on your account. This rate may change during the repayment of your account.';
        break;
      }
      default: {
        toolTip = 'No ToolTip message has been defined for ' + element;
        break;
      }
    }
    return toolTip;
  }
}
